import { Api } from '@/services/Api';

export default {
    getFieldSecurity(body) { 
        return Api().post(`/SecurityField/GetFieldSecurity`, body);
  },
  saveFieldSecurity(body) {
      return Api().post(`/SecurityField`, body);
  },
}